import { PropType, defineComponent, h } from 'vue'
import ComplexAutoModal from './AutoModal.vue'
import { FloatValue } from './floatData'
import { reactiveLayout } from '@/plugin'

export default defineComponent({
  name: 'FloatItem',
  props: {
    data: {
      type: Object as PropType<FloatValue>,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
  },
  watch: {
    'data.show': {
      immediate: true,
      handler: function (value) {
        if (value) {
          if (!this.data.init) {
            this.data.init = true
            this.$nextTick(() => {
              this.show()
            })
          }
        }
      }
    }
  },
  methods: {
    show() {
      (this.$refs.modal as any).show(this.data.autoModal.title)
      this.$nextTick(() => {
        if (typeof (this.$refs.content as any).$show === 'function') {
          (this.$refs.content as any).$show(...this.data.autoModal!.show)
        }
      })
    },
    close() {
      (this.$refs.modal as any).close()
      this.$emit('remove', this.index, this.data)
    },
    hide() {
      this.data.show = false;
      (this.$refs.modal as any).$hide()
    },
    handle(next: (payload: any) => void) {
      if ((this.$refs.content as any).$handle) {
        (this.$refs.content as any).$handle((payload: any) => {
          next(payload)
        })
      } else {
        next({})
      }
    },
    renderContent() {
      if (!this.data.init && !this.data.show) {
        // 未加载未展示直接不进行构建
        return null
      }
      return h(ComplexAutoModal, {
        class: 'float-item-modal',
        ref: 'modal',
        optionProps: {
          width: this.data.autoModal.width || reactiveLayout.data.main.width,
          destroyOnClose: this.data.autoModal.destroyOnClose || false,
          maskClosable: this.data.autoModal.maskClosable || false
        },
        menuList: this.data.autoModal.menu,
        heightLayout: this.data.autoModal.heightLayout,
        onEvent: (act: 'show' | 'cancel' | 'hide' | 'ok' | 'okAndHide') => {
          if (act === 'ok') {
            this.handle((payload: any) => {
              this.data.autoModal.event(act, (this.$refs.modal as any), this.data, payload)
            })
            return
          } else if (act === 'okAndHide') {
            this.handle((payload: any) => {
              this.hide()
              this.data.autoModal.event(act, (this.$refs.modal as any), this.data, payload)
            })
            return
          } else if (act === 'hide') {
            this.hide()
          } else if (act === 'cancel') {
            this.close()
          }
          this.data.autoModal.event(act, (this.$refs.modal as any), this.data)
        }
      }, {
        default: (payload: any) => {
          return h(this.data.component(), {
            class: 'float-item-content',
            ref: 'content',
            payload: payload,
            float: this.data,
            onHideOk: () => {
              const index = this.data.autoModal.menu!.indexOf('ok')
              if (index > -1) {
                this.data.autoModal.menu!.splice(index, 1)
              }
            },
            onEvent: (act: string, ...args: unknown[]) => {
              if (this.data.event) {
                this.data.event(act, this as any, ...args)
              }
            },
            ...this.data.props
          })
        }
      })
    },
    renderName() {
      return h('div', {
        class: 'float-item-name',
        onClick: () => {
          if (!this.data.show) {
            this.data.show = true;
            (this.$refs.modal as any).$show()
          }
        }
      }, {
        default: () => this.data.name
      })
    }
  },
  render() {
    return h('div', {
      class: ['float-item', this.data.show ? 'choice' : '']
    }, {
      default: () => [this.renderContent(), this.renderName()]
    })
  }
})
